import { styled } from 'goober';
import { forwardRef } from 'react';
export var ModalHeaderStyled = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '30px 30px 0px',
        fontSize: '18px',
        fontWeight: 600,
        color: theme === null || theme === void 0 ? void 0 : theme.colors.ui.dark,
    });
});
export var ColorPickerModal = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $top = _a.$top, $left = _a.$left;
    return {
        position: 'absolute',
        animation: 'fadeIn',
        animationDuration: '0.5s',
        zIndex: 99999,
        top: $top,
        left: $left,
        display: 'flex',
    };
});
export var ModalCloseBtn = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        outline: 'none',
        color: theme === null || theme === void 0 ? void 0 : theme.colors.neutral.w700,
        opacity: 1,
        padding: '0px',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        '-webkit-appearance': 'none',
        float: 'right',
        fontSize: '22px',
        lineHeight: 1,
        ':hover': {
            opacity: 0.5,
        },
    });
});
export var ChartModalCloseBtn = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        outline: 'none',
        color: theme === null || theme === void 0 ? void 0 : theme.colors.neutral.w700,
        opacity: 1,
        display: 'flex',
        position: 'relative',
        height: '22px',
        right: '30px',
        top: '12px',
        padding: '0px',
        background: 'transparent',
        cursor: 'pointer',
        border: 'none',
        '-webkit-appearance': 'none',
        float: 'right',
        fontSize: '22px',
        lineHeight: 1,
        ':hover': {
            opacity: 0.5,
        },
    });
});
export var ModalBody = styled('div')(function () { return ({
    padding: '30px',
}); });
export var ModalFooterStyled = styled('div')(function () { return ({
    padding: '0px 30px 30px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'flex-end',
    position: 'relative',
}); });
